<template>
  <a style="display: inline-block;height: 40px;width: 40px;" href="https://discord.gg/jDFMSeDH9t"  target="_blank">
    <Btn @click="$emit('click')" class="bouton-discord"/>
  </a>
</template>

<style lang="scss" scoped>
.bouton-discord {
  cursor: pointer;
  user-select: none;


  .contour {
    fill: #000;
  }

  &:hover .contour {
    fill: #3b3b3b;
  }

  &:active .contour {
    fill: #000;
  }

  $color: #738ADB;

  .background {
    fill: $color;
  }

  &:hover .background {
    fill: lighten($color, 3%);
  }

  &:active .background {
    fill: darken($color, 5%);
  }


  .inside {
    fill: #ffffff;
  }

  /*&:hover .inside {
    fill: #222222;
  }*/

  &:active .inside {
    fill: darken(#ffffff, 5%);
  }

}
</style>

<script>
import Btn from '@/resources/images/inline.bouton_discord.svg';

export default {
  name: 'BoutonDiscord',
  components: {
    Btn: Btn,
  },
}
</script>
